export const GlossaryConst = {
  GLOSSARY_TERM_NAME: 'Glossary Term name',
  NO_GLOSSARY_TERM_SELECTED: 'No Glossary Term selected',
  SELECTED_TEXT: 'Selected text',
  GLOSSARY_TERM_MODAL: ' Glossary Term Modal',
  CREATE_NEW_GLOSSARY_TERM: 'Create New Glossary Term',
  NO_RESULTS_FOUND: 'No results found',
  SEARCH_BY_TERM: 'Search by Term',
  PREVIEW: 'Preview',
  SET: 'Set',
  DEFINITION: 'Definition',
  SAVE_AND_LINK: 'Save & Link',
  LINK: 'Link',
  CLOSE: 'Close',
  UNLINK: 'Unlink'
};